import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Array$isArray from "@babel/runtime-corejs3/core-js-stable/array/is-array";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import invariant from 'invariant';
import { merge } from 'lodash';

function parseQuery(_ref) {
  var token = _ref.token,
      query = _ref.query,
      namespace = _ref.namespace;

  // Allow for passing token functions as queries
  if (typeof query === 'function') {
    return query({
      token: token
    });
  } // If we pass in a string then use it to find a default token


  if (typeof query === 'string') {
    var _context;

    return token(_concatInstanceProperty(_context = "".concat(namespace, ".")).call(_context, query));
  }

  return query;
}

function parseMediaQueries(_ref2, token) {
  var _context2;

  var propMinWidth = _ref2.minWidth,
      propMaxWidth = _ref2.maxWidth;
  var minWidth = parseQuery({
    token: token,
    query: propMinWidth,
    namespace: 'breakpoint'
  });
  var maxWidth = parseQuery({
    token: token,
    query: propMaxWidth,
    namespace: 'breakpoint'
  });
  invariant(minWidth || maxWidth, "Must define either a 'minWidth' or 'maxWidth'");

  if (minWidth && maxWidth) {
    invariant(minWidth < maxWidth, "'minWidth' can not be greater than 'maxWidth'");
  }

  var minBreakpoint = minWidth && "(min-width: ".concat(minWidth, "px)");
  var maxBreakpoint = maxWidth && "(max-width: ".concat(maxWidth - 1, "px)");
  return _filterInstanceProperty(_context2 = [minBreakpoint, maxBreakpoint]).call(_context2, Boolean).join(' and ');
}

export function createMedia(queries, token) {
  if (_Array$isArray(queries)) {
    return _mapInstanceProperty(queries).call(queries, function (config) {
      return parseMediaQueries(config, token);
    }).join(', ');
  }

  return parseMediaQueries(queries, token);
}
export function createMediaQuery(queries, token) {
  return "@media ".concat(createMedia(queries, token));
}

function createMediaQueryStyle(_ref3, token) {
  var target = _ref3.target,
      queries = _ref3.queries,
      styles = _ref3.styles;
  return _defineProperty({}, token(target, createMediaQuery(queries, token)), styles);
}

function styles(args) {
  return {
    '&': function _(_ref5) {
      var token = _ref5.token;
      return createMediaQueryStyle(args, token);
    }
  };
}

styles.combine = function () {
  var mediaQueries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return {
    '&': function _(_ref6) {
      var token = _ref6.token;
      return _reduceInstanceProperty(mediaQueries).call(mediaQueries, function (acc, args) {
        return merge(acc, createMediaQueryStyle(args, token));
      }, {});
    }
  };
};

export var mq = {
  styles: styles
};